// extracted by mini-css-extract-plugin
export var addressFields = "_gn-0";
export var animationContainer = "_gn-1";
export var footer = "_gn-2";
export var lineItems = "_gn-3";
export var modalContent = "_gn-4";
export var orderName = "_gn-5";
export var strong = "_gn-6";
export var warning = "_gn-7";